import React from 'react'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'
import Input from 'components/Input'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'

import { CLAIM_UPDATE } from 'constants'

import './styles.scss'

export class Driver extends BaseComponent {


  constructor(props) {
    super(props)
    this.state = {
      editting: false,
      driver_available: this.props.claim.driver_available,
      driver_name: this.props.claim.driver_name || '',
      driver_phone: this.props.claim.driver_phone || '',
      driver_age: this.props.claim.driver_age || '',
      driver_email: this.props.claim.driver_email || ''
    }

    this._bind( 
                '_onEdit', '_renderEditForm', '_renderData', '_handleSubmit', 
                '_renderButton', '_handleChange', '_onCancelEdit',
                '_renderDriver', '_renderDriverForm')
  }

  componentDidMount() {
  
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: true })
  }

  _onCancelEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: false })
  }

  _renderHeaderActions() {
    return !this.state.editting ? (
      <div>
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : (
      <div>
        <button onClick={this._onCancelEdit}>
          <i className="material-icons">close</i>
        </button>
      </div>
    )
  }

  _renderButton() {
    const isActive = this.state.isActive
    const isClosed = this.state.isClosed
    if(isActive && isClosed === false) {
      return (
        <button type="button" className="btn btn-outline-danger" onClick={this._claimStatus} name="is_closed">Terminar seguimiento</button>
      )
    } else {
      return (
        <button type="button" className="btn btn-outline-success" onClick={this._claimStatus} name="is_active">Iniciar seguimiento</button>
      )
    }
  }

  _handleSubmit(e) {
    e.preventDefault()
    const formData = new FormData()
    var driverUpdated = this.state.driver_name !== '' || this.state.driver_phone !== '' || this.state.driver_email !== ''
    this.setState({
      driver_available: driverUpdated
    })

    formData.append('driver_available', driverUpdated) 

    if(driverUpdated){
      formData.append('driver_name', this.state.driver_name)
      formData.append('driver_phone', this.state.driver_phone) 
      formData.append('driver_email', this.state.driver_email) 
      formData.append('driver_age', this.state.driver_age) 
    }else{
      formData.append('driver_name', '') 
      formData.append('driver_phone', '') 
      formData.append('driver_email', '') 
      formData.append('driver_age', 0) 
    }

    this.props.updateRequestStatus('progress', 'Modificando datos del siniestro...')
    request(CLAIM_UPDATE(this.props.claim.id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Datos modificados')
      this.props.claimChanged({
        ...this.props.claim,
        driver_available: driverUpdated,
        driver_name: this.state.driver_name,
        driver_phone: this.state.driver_phone,
        driver_email: this.state.driver_email,
        driver_age: this.state.driver_age
      })
    }).catch((err) => {this.props.updateRequestStatus('error', 'No pudimos modificar los datos')})

    this.setState({
      editting: false
    })
  }

  _handleChange(e) {
    this.setState({ [e.target.name]: e.target.value })      
  }

  _renderEditForm() {
    return(
      <form onSubmit={this._handleSubmit} className="DriverData__form">
        {this._renderDriverForm()}
        <div className="controls d-flex justify-content-end">
          <Button buttonType="primary"
                  size="small">Actualizar siniestro</Button>
        </div>
      </form>
    )
  }

  _renderDriverForm() {
    return (
      <div className="DriverDataForm">
        <div className="form-field">
          <label>Nombre:</label>
          <Input  onChange={this._handleChange}
                name="driver_name"
                value={this.state.driver_name}
                placeholder="Nombre del conductor"/>
        </div>
        <div className="form-field">
          <label>Edad:</label>
          <Input  onChange={this._handleChange}
                name="driver_age"
                value={this.state.driver_age}
                placeholder="Edad del conductor"/>
        </div>
        
        <div className="form-field">
          <label>Teléfono:</label>
          <Input  onChange={this._handleChange}
                name="driver_phone"
                value={this.state.driver_phone}
                placeholder="Teléfono del conductor"/>
        </div>


        <div className="form-field">
          <label>Correo:</label>
          <Input  onChange={this._handleChange}
                name="driver_email"
                value={this.state.driver_email}
                placeholder="Email del conductor"/>
        </div>
      </div>
    )
  }

  _renderData() {
    return(
      <div className="DriverData__data">
        {this._renderDriver()}
      </div>
    )
  }

  _renderDriver() {
    const driverAvailable = this.props.claim.driver_available

    return !!driverAvailable ? (
      <div>
        <div className="data-field">
          <label>Nombre:</label>
          <p><span>{this.props.claim.driver_name}</span></p>
        </div>
        <div className="data-field">
          <label>Edad:</label>
          <p><span>{this.props.claim.driver_age}</span></p>
        </div>
        <div className="data-field">
          <label>Teléfono:</label>
          <p><span>{this.props.claim.driver_phone}</span></p>
        </div>
        <div className="data-field">
          <label>Email:</label>
          <p><span>{this.props.claim.driver_email}</span></p>
        </div>
      </div>
    ) : (
      <center><p><span>No registrado</span></p></center>
    )
  }

  render() {
    return(
      <div id="DriverData" className="DriverData">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Datos del conductor"
          actionButtons={this._renderHeaderActions()}
          isToggle={true}
        >
          {this.state.editting ? this._renderEditForm() : this._renderData() }
        </RetractablePanel>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    claim: state.vehicleDetail.get('claim')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Driver)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Driver/index.js